import { create } from 'zustand';

interface IActiveBonusesTabState {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
}

export const useActiveBonusesTabStore = create<IActiveBonusesTabState>(
  (set) => ({
    isOpen: false,
    setOpen: (isOpen) => set({ isOpen }),
  })
);
